import React, { useState } from 'react';
import cx from 'classnames';
import { FixedSizeList as List } from 'react-window';
// BluePrint JS
import { Menu, MenuItem, MenuDivider } from '@blueprintjs/core';
import { Button, TextInput, Popover, Icons } from '..';
import { searchIcon, chevronIcon, crossIcon, tickIcon } from './functions/icons';
import { getCategoryButton, getNewSelectedItems } from './functions/helper';
export const Filter = ({ categoryName, filterItems, selectedItems = [], updateItems, type = 'multiple', languageData, iconCategories, showClear = true, isCategoryNameRequired = true, theme, }) => {
    const { noMatchesFound, filterValue, clearValue } = languageData;
    const [searchValue, setSearchValue] = useState('');
    let canSearch = false;
    const buttonComponent = getCategoryButton(categoryName, selectedItems, iconCategories, isCategoryNameRequired, theme);
    const resetSearchValue = () => {
        setSearchValue('');
    };
    const selectItem = (item) => {
        updateItems(getNewSelectedItems(item, selectedItems, type));
    };
    const clearItems = () => updateItems([]);
    if (filterItems.length >= 20) {
        canSearch = true;
    }
    // Make sure it's a case-insensitive search
    const searchItems = filterItems.filter(({ label }) => label.toLowerCase().includes(searchValue.toLowerCase()));
    const isClearDisabled = selectedItems.length === 0;
    const noResults = React.createElement("div", { className: "filter-no-results" }, noMatchesFound);
    const row = ({ index, style }) => {
        const { key, label, icon, className, showDivider, isDisable } = searchItems[index];
        const isSelected = selectedItems.findIndex(item => item.key === key) !== -1;
        const rightIcon = isSelected ? tickIcon : null; // [1]
        const selectItemOnClick = () => selectItem(searchItems[index]);
        const selectItemOnKeyPress = (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                selectItem(searchItems[index]);
            }
        };
        const createdIcon = (React.createElement(Icons, { iconName: `ic-${icon}`, title: `ic-${icon}`, className: cx(icon, className), size: 24, style: theme &&
                icon &&
                icon.indexOf('ad-') === 0 && {
                fill: theme[key.toLowerCase()],
                color: theme[key.toLowerCase()],
            } }));
        return (React.createElement("div", { style: style },
            React.createElement(MenuItem, { className: cx('filter-menu-item', {
                    'filter-item-selected': isSelected,
                    'filter-empty-value': key === 'NullValue',
                }), key: `filter-item-${key}`, onClick: selectItemOnClick, onKeyPress: selectItemOnKeyPress, text: label, labelElement: rightIcon, icon: icon ? createdIcon : undefined, shouldDismissPopover: false, tabIndex: 0, disabled: isDisable ? true : false }),
            showDivider && React.createElement(MenuDivider, { className: "filter-menu-divider" })));
    };
    const createFilterMenu = () => {
        const itemCount = searchItems.length;
        const listHeight = itemCount < 8 ? itemCount * 40 : 300;
        return (React.createElement(Menu, null,
            React.createElement(List, { height: listHeight, width: 250, itemSize: 40, itemCount: itemCount }, row)));
    };
    const setSearchOnChange = (e) => setSearchValue(e.target.value);
    return (React.createElement(Popover, { position: "bottom-left", transitionDuration: 0, autoFocus: true },
        React.createElement(Button, { className: "filter-category-button", style: "subtle", rightIcon: chevronIcon, "aria-label": categoryName + ' filter', onClick: resetSearchValue }, buttonComponent),
        React.createElement("div", { className: "filter-popover-content" },
            canSearch && (React.createElement("div", { className: "filter-search" },
                React.createElement(TextInput, { icon: searchIcon, value: searchValue, onChange: setSearchOnChange, placeholder: filterValue, autoFocus: true }))),
            searchItems.length > 0 ? createFilterMenu() : noResults,
            showClear && (React.createElement("div", { className: "filter-clear" },
                React.createElement(Button, { style: "subtle", onClick: clearItems, leftIcon: crossIcon, disabled: isClearDisabled }, clearValue))))));
};
//# sourceMappingURL=Filter.js.map